document.addEventListener('DOMContentLoaded', () => {
  function waitForElement(selector, callback, timeout = 5000) {
    const intervalTime = 100;
    let elapsedTime = 0;
    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        callback(element);
      }
      elapsedTime += intervalTime;
      if (elapsedTime >= timeout) {
        clearInterval(interval);
        console.warn(`Element ${selector} not found within timeout.`);
      }
    }, intervalTime);
  }

  waitForElement('#new-form-atc', (addToCartBtn) => {
    function updateDiscountText() {
        const existingDiscountText = addToCartBtn.querySelector('.custom-dicount-text');
        if (existingDiscountText) existingDiscountText.remove();

        const selectedOption = document.querySelector('.new-form-option.corner-offer-container.selectedWB');

        if (selectedOption) {
          const discountTextSpan = selectedOption.querySelector('.custom-dicount-text');
          if (discountTextSpan) {
            const discountClone = discountTextSpan.cloneNode(true);
            addToCartBtn.appendChild(discountClone);
          }
        }
    }

    updateDiscountText();

    waitForElement('.new-form-option.corner-offer-container', (dummy) => {
      document.querySelectorAll('.new-form-option.corner-offer-container').forEach(div => {
        div.addEventListener('click', () => {
          document.querySelectorAll('.new-form-option.corner-offer-container.selectedWB').forEach(el => {
            el.classList.remove('selectedWB');
          });
          div.classList.add('selectedWB');
          updateDiscountText();
        });
      });
    });
  });
});


if (typeof jQuery !== "undefined") {


jQuery(document).ready(function ($) {
  setTimeout(function () {
    $(
      "body.kertox-botox-5.page-kertox-botox-5.cstm-scroll.kertox.botox button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click"),
      $(
        "body.kertox-2.page-kertox-2.cstm-scroll.Kertox-2 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
      ).trigger("click"),
      $(
        "body.beneficous_page button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
      ).trigger("click"),
      $(
        "body.blog-captacio button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
      ).trigger("click"),
      $(
        "body.blog-captacio-new button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
      ).trigger("click"),
      $(
        "body.blog-captacio-new-1 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
      ).trigger("click");

    $(
      "body.page-details-14 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-15 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-16 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-17 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-18 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-19 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-20 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-21 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-22 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
    $(
      "body.page-details-23 button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
    ).trigger("click");
  }, 8e3);

  var product_html = $(".custm-flx-sect-wrap").html();
  $("div#template-page-blog-captacio-page").append(product_html);
  $("div#template-page-blog-captacio-page-2").append(product_html);
  $("div#template-page-blog-captacio-page-3").append(product_html);
  $("div#template-page-blog-captacio-page-4").append(product_html);

  $(
    "div#template-page-blog-captacio-page .dynamic-sections, div#template-page-blog-captacio-page .product_section.product-section-wrap-our"
  ).wrapAll('<div class="container"><div class="wrapper_all_blg"></div></div>'),
    $(
      "div#template-page-blog-captacio-page-2 .dynamic-sections, div#template-page-blog-captacio-page-2 .product_section.product-section-wrap-our"
    ).wrapAll(
      '<div class="container"><div class="wrapper_all_blg"></div></div>'
    ),
    $(
      "div#template-page-blog-captacio-page-3 .dynamic-sections, div#template-page-blog-captacio-page-3 .product_section.product-section-wrap-our"
    ).wrapAll(
      '<div class="container"><div class="wrapper_all_blg"></div></div>'
    ),
    $(
      "div#template-page-blog-captacio-page-4 .dynamic-sections, div#template-page-blog-captacio-page-4 .product_section.product-section-wrap-our"
    ).wrapAll(
      '<div class="container"><div class="wrapper_all_blg"></div></div>'
    ),
    setTimeout(function () {
      $("body.blog-captacio.page-blog-captacio-page").css("opacity", "1"),
        $("body.blog-captacio-new.page-blog-captacio-page-2").css(
          "opacity",
          "1"
        ),
        $("body.blog-captacio-new-1.page-blog-captacio-page-3").css(
          "opacity",
          "1"
        ),
        $("body.blog-captacio-new-2.page-blog-captacio-page-4").css(
          "opacity",
          "1"
        );
    }, 100);

  $(window).scroll(function () {
    var o,
      t = $(this).scrollTop();
    t >= document.documentElement.scrollHeight / 2
      ? $(".product-sticky-sect-main").addClass("custom-sticky-prod")
      : $(".product-sticky-sect-main").removeClass("custom-sticky-prod");
  }),
    $(".custom-bundle-img-text").click(function () {
      $(".custom-bundle-img-text").removeClass("active"),
        $(this).addClass("active");
    });

  // Remove 'active' class from all packs and add to the last pack by default
  $(".pack").removeClass("active").last().addClass("active");

  // Add click event listener to packs
  $(".pack").on("click", function () {
    // Remove 'active' class from all packs
    $(".pack").removeClass("active");

    // Add 'active' class to the clicked pack
    $(this).addClass("active");
  });

  // Set the end date for the countdown (change to your desired date)
  var endDate = new Date("oct 20, 2024 23:59:59").getTime();

  // Update the countdown every second
  var countdownFunction = setInterval(function () {
    // Get the current time
    var now = new Date().getTime();

    // Find the time difference between now and the countdown end date
    var timeLeft = endDate - now;

    // Calculate time components: hours, minutes, seconds
    var hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Format numbers to be two digits
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    // Display the result in the corresponding elements
    $(".hours").text(hours);
    $(".minutes").text(minutes);
    $(".seconds").text(seconds);

    // If the countdown ends, stop the timer and display a message
    if (timeLeft < 0) {
      clearInterval(countdownFunction);
      $(".hours").text("00");
      $(".minutes").text("00");
      $(".seconds").text("00");
      // alert("La promoción ha terminado");
    }
  }, 1000);

  // $(".custom-add-to").click(function () {
  //   var variant_id = $(this).attr("variant-id");
  //   let formData = {
  //     items: [
  //       {
  //         id: variant_id,
  //         quantity: 1,
  //       },
  //     ],
  //   };

  //   fetch(window.Shopify.routes.root + "cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(formData),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Redirect to the cart after successfully adding the item
  //       window.location.href = "/cart";
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // });

  var array_value = [
    1467, 1512, 1498, 1523, 1550, 1589, 1456, 1541, 1473, 1537, 1509, 1574,
    1460, 1595, 1505, 1446, 1562, 1494, 1583, 1459, 1591, 1516, 1437, 1554,
    1503, 1531, 1579, 1565, 1442, 1488, 1529, 1490, 1590, 1439, 1549, 1513,
    1471, 1507, 1496, 1552, 1571, 1458, 1443, 1522, 1469, 1580, 1535, 1519,
    1597, 1441, 1482, 1568, 1577, 1453, 1587, 1599, 1501, 1548, 1499, 1465,
    1564, 1551, 1448, 1486, 1438, 1576, 1492, 1584, 1561, 1593, 1525, 1481,
  ];

  var index = 0;
  function showNextValue() {
    var value = array_value[index];

    var div = document.querySelector(".live_vistor");
    var fade_cls = document.querySelector(".fade_cstm_value");

    fade_cls.classList.remove("fade_new_cstm");
    fade_cls.classList.add("fade_new");

    setTimeout(function () {
      fade_cls.classList.add("fade_new_cstm");
      fade_cls.classList.remove("fade_new");
      div.innerHTML = value;
    }, 200);
    index = (index + 1) % array_value.length;
  }
  if (document.querySelector(".live_vistor")) {
    setInterval(showNextValue, 3600000);
  }

  $(".custom-cross-icon").on("click", function () {
    $(".count-custm-active").removeClass("count-custm-active");
  });

  var productName = $(
    "body.kertox-botox-instantaneo .product_name.title"
  ).text();

  // Split the text into two parts
  var splitText = productName.split(", ");
  // Replace the original text with the first part in the current tag
  $("body.kertox-botox-instantaneo .product_name.title").html(
    splitText[0] +
      ", <span class='subtitle-custm-bld'>" +
      splitText[1] +
      "</span>"
  );

  var productName_subtitle = $("body.kertox-100 .product_name.title").text();

  // Split the text into two parts
  var splitText_subtitle = productName_subtitle.split(", ");
  // Replace the original text with the first part in the current tag
  $("body.kertox-100 .product_name.title").html(
    splitText_subtitle[0] +
      ", <span class='subtitle-custm-bld'>" +
      splitText_subtitle[1] +
      "</span>"
  );

  var productName_subtitle_ker = $(
    "body.kertox-efecto-botox-capilar-instantaneo .product_name.title"
  ).text();

  // Split the text into two parts
  var splitText_subtitle_ker = productName_subtitle_ker.split(", ");
  // Replace the original text with the first part in the current tag
  $("body.kertox-efecto-botox-capilar-instantaneo .product_name.title").html(
    splitText_subtitle_ker[0] +
      ", <span class='subtitle-custm-bld'>" +
      splitText_subtitle_ker[1] +
      "</span>"
  );
});
}

document.addEventListener("DOMContentLoaded", function () {
  const promoBtn = document.querySelector(".promo-button");
  const customBtn = document.querySelector(".custom-btn-triger"); // Confirm class spelling
  const ctaBtn = document.querySelector(".am-widgetbar-cta");

  if (promoBtn && ctaBtn) {
    promoBtn.addEventListener("click", function (e) {
      e.preventDefault();
      ctaBtn.click();
    });
  }

  if (customBtn && ctaBtn) {
    customBtn.addEventListener("click", function (e) {
      e.preventDefault();
      ctaBtn.click();
    });
  }
});





